import { useTranslation } from "react-i18next";
import CustomCard from "../../../CustomCard";
import VariantTable from "./components/VariationTable";

const MIN_VARIANT_COUNT = 2;

const VariantManage = ({
  form,
  attributes,
  products,
  dataSource,
  setDataSource,
  disabledInputInfo,
  disabledInputPrice,
  isActionCreate,
}) => {
  const { t } = useTranslation();
  // const [openInfoPrice, setOpenInfoPrice] = useState(false);

  // const handleFormInfoPrice = () => {
  //   const formData = form.getFieldsValue();
  //   const { products } = formData;
  //   const { price, priceVat } = formData?.productPrices;
  //   const newDataSource = [...dataSource]?.map((item) => ({
  //     ...item,
  //     price: price,
  //     priceVat: priceVat,
  //     vat: formData?.vat,
  //     vatPercent: formData?.vatPercent,
  //   }));

  //   form.setFieldsValue({
  //     ...form.getFieldsValue(),
  //     products: products?.map((item) => ({
  //       ...item,
  //       productPrices: {
  //         price: price,
  //         priceVat: priceVat,
  //       },
  //       vat: formData?.vat,
  //       vatPercent: formData?.vatPercent,
  //     })),
  //   });
  //   setDataSource([...newDataSource]);

  //   setOpenInfoPrice(!openInfoPrice);
  // };

  // const handleOpenModal = () => {
  //   form.setFieldsValue({
  //     ...form.getFieldsValue(),
  //     productPrices: {
  //       importPrice: undefined,
  //       price: undefined,
  //       priceVat: undefined,
  //     },
  //     vat: false,
  //     vatPercent: undefined,
  //   });
  // };

  return (
    <CustomCard title={t("product.productForm.variantManage")}>
      {/* {disabledInputPrice && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
          <CustomModal
            title={<b>{t("product.productForm.infoPrice")}</b>}
            customComponent={<CreateButton title={t("product.productForm.inputPrices")} onClick={handleOpenModal} />}
            closable={false}
            centered={true}
            footer={false}
            isBlockCloseOnOke
            width="fit-content"
            switchClose={openInfoPrice}
            onOke={() => handleFormInfoPrice()}
            onCancel={() => {
              setOpenInfoPrice(!openInfoPrice);
            }}
            forceRender={true}
            getContainer={false}
          >
            <PriceInfo form={form} />
          </CustomModal>
        </div>
      )} */}
      <VariantTable
        form={form}
        attributes={attributes}
        products={products}
        dataSource={dataSource}
        setDataSource={setDataSource}
        disabledInputInfo={disabledInputInfo}
        disabledInputPrice={disabledInputPrice}
        isActionCreate={isActionCreate}
      />
      {(dataSource?.length || 0) < MIN_VARIANT_COUNT && (
        <div style={{ textAlign: "center", color: "#FF4D4F" }}>Sản phẩm biến thể phải có ít nhất 2 biến thể</div>
      )}
    </CustomCard>
  );
};

export default VariantManage;
